import React, { useState } from "react";
import { notify } from "../../components/ui/notify";
import { Button } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { HappyProvider } from "@ant-design/happy-work-theme";

import { actionUsuarioCreate } from "../../redux/actions/usuarios/usuarios";
import "../../components/forms/tribunal/FormTribunal.css";

const collapseSpaces = (s) => String(s ?? "").normalize("NFC").replace(/\s+/g, " ").trim();

export default function CrearUsuarioPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({ name: "", email: "", password: "" });

  const setField = (name, value) => {
    setForm((f) => ({ ...f, [name]: value }));
    setErrors((e) => { const c = { ...e }; delete c[name]; return c; });
  };

  const handleBack = () => navigate("/usuarios");

  const validate = () => {
    const e = {};
    if (!collapseSpaces(form.name)) e.name = "Campo requerido";
    const email = collapseSpaces(form.email);
    if (!email) e.email = "Campo requerido";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) e.email = "Correo inválido";
    if (!form.password || form.password.length < 6) e.password = "Mínimo 6 caracteres";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    const payload = {
      name: collapseSpaces(form.name),
      email: collapseSpaces(form.email).toLowerCase(),
      password: form.password,
    };

    try {
      setSubmitting(true);
      await dispatch(actionUsuarioCreate(payload));
      notify.success({ message: "Usuario creado", placement: "bottomRight" });
      navigate("/usuarios");
    } catch (e) {
      const msg = e?.response?.data?.detail || e?.message || "Error al guardar";
      notify.error({ message: "No se pudo guardar", description: msg, placement: "bottomRight" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <HappyProvider>
      <div className="oa-exp-page">
        {/* ── TOPBAR ─────────────────────────────────────────────────── */}
        <section className="oa-exp-topbar">
          <div className="oa-exp-topbar-left">
            <div className="oa-exp-title">Creando Usuario</div>
            <div className="oa-exp-subtitle">Usuarios del sistema</div>
          </div>
          <div className="oa-exp-topbar-right">
            <Button className="oa-exp-btn oa-exp-btn-ghost" onClick={handleBack}>
              Cancelar
            </Button>
            <Button
              type="primary"
              className="oa-exp-btn"
              disabled={submitting}
              loading={submitting}
              onClick={handleSubmit}
              icon={
                <svg viewBox="0 0 448 512" width="13" height="13" fill="currentColor" aria-hidden="true">
                  <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L400 60.7C388 48.7 371.7 42 354.5 42H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
                </svg>
              }
            >
              Crear usuario
            </Button>
          </div>
        </section>

        {/* ── BODY ───────────────────────────────────────────────────── */}
        <main className="oa-exp-main">
          <section className="oa-card">
            <div className="oa-card-head">
              <h2 className="oa-card-title">
                <span className="oa-card-icon">
                  <i className="fa-solid fa-user" />
                </span>
                DATOS DEL USUARIO
              </h2>
            </div>

            <div className="oa-card-body oa-grid-3">
              <div className="oa-field">
                <label className="oa-label">
                  <span className="oa-req">*</span> Nombre
                </label>
                <input
                  className={`oa-input ${errors.name ? "oa-input-error" : ""}`}
                  type="text"
                  placeholder="Nombre completo"
                  maxLength={150}
                  value={form.name}
                  onChange={(e) => setField("name", e.target.value)}
                />
                {errors.name && <div className="oa-error">{errors.name}</div>}
              </div>

              <div className="oa-field">
                <label className="oa-label">
                  <span className="oa-req">*</span> Correo
                </label>
                <input
                  className={`oa-input ${errors.email ? "oa-input-error" : ""}`}
                  type="email"
                  placeholder="correo@ejemplo.com"
                  maxLength={150}
                  value={form.email}
                  onChange={(e) => setField("email", e.target.value)}
                />
                {errors.email && <div className="oa-error">{errors.email}</div>}
              </div>

              <div className="oa-field">
                <label className="oa-label">
                  <span className="oa-req">*</span> Contraseña
                </label>
                <input
                  className={`oa-input ${errors.password ? "oa-input-error" : ""}`}
                  type="password"
                  placeholder="Contraseña"
                  value={form.password}
                  onChange={(e) => setField("password", e.target.value)}
                />
                {errors.password && <div className="oa-error">{errors.password}</div>}
              </div>
            </div>
          </section>
        </main>
      </div>
    </HappyProvider>
  );
}
